import { APIHandler } from "../apiHandler";

class BuildHandler extends APIHandler {
  async get() {
    // Status and message content don't matter here.
    // Without these fields, errors get thrown.
    const response = { status: "STATIC_STATUS", message: "STATIC_MESSAGE" };
    this.finish(response);
  }
}

export const defaultHandlers: [string, typeof APIHandler][] = [
  ["/lab/api/build", BuildHandler],
];
